import { Data } from 'signup-constants/signupData/Data';
import { trackInteraction } from './trackEvent';
import { getSignupDataGtkmData } from '../store/signup-data/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
export const trackGTKMDataChanged = state => {
  const companyDomain = getSignupDataValue(state, Data.CompanyDomain);
  const gtkmCompanyDomain = getSignupDataGtkmData(state, Data.CompanyDomain);
  const companyName = getSignupDataValue(state, Data.CompanyName);
  const gtkmCompanyName = getSignupDataGtkmData(state, Data.CompanyName);
  const industry = getSignupDataValue(state, Data.Industry);
  const gtkmIndustry = getSignupDataGtkmData(state, Data.Industry);
  const companySize = getSignupDataValue(state, Data.CompanySize);
  const gtkmCompanySize = getSignupDataGtkmData(state, Data.CompanySize);
  const isAssignedToACQ173VariantAorC = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0173, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_C]);
  if (isAssignedToACQ173VariantAorC && companyDomain && companyDomain !== gtkmCompanyDomain) {
    trackInteraction({
      action: `gtkm-company-domain-changed`
    });
  }
  if (isAssignedToACQ173VariantAorC && companyName && companyName !== gtkmCompanyName) {
    trackInteraction({
      action: `gtkm-company-name-changed`
    });
  }
  if (isAssignedToACQ173VariantAorC && industry && industry !== gtkmIndustry) {
    trackInteraction({
      action: `gtkm-industry-changed`
    });
  }
  if (isAssignedToACQ173VariantAorC && companySize && companySize !== gtkmCompanySize) {
    trackInteraction({
      action: `gtkm-company-size-changed`
    });
  }
};